import { featuresStorage, FeatureData } from '@bees-web/core/shared'
import { useEffect } from 'react'

import { DevToolDataUpdater } from '../provider/types'

let originalSetData: ((data: FeatureData) => void) | null = null

export function useFeatureTogglesMonitor(
  updateData: DevToolDataUpdater,
  isEnabled: boolean
): void {
  useEffect(() => {
    if (!isEnabled || originalSetData) return

    const storageInstance = featuresStorage()
    originalSetData = storageInstance.setData.bind(storageInstance)

    const existingData = storageInstance.data
    if (existingData && Object.keys(existingData).length > 0) {
      updateData({
        type: 'FEATURE_TOGGLES',
        payload: existingData,
      })
    }

    storageInstance.setData = (data: FeatureData) => {
      originalSetData?.(data)
      updateData({
        type: 'FEATURE_TOGGLES',
        payload: data,
      })
    }
  }, [updateData, isEnabled])
}
